"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCartTotals = exports.getCartCount = exports.getTotalPrice = exports.getCouponTotal = exports.getTargetAmountForFreeShipping = exports.getShippingPrice = exports.getPrepaidDiscount = void 0;
const types_1 = require("../types");
const cart_1 = require("../types/cart");
const coupons_1 = require("./coupons");
const getPrepaidDiscount = (totalPrice, couponTotal, prepaidPercentage, maxPrepaidDiscount) => {
    const discountedPrice = ((totalPrice - couponTotal) / 100) * prepaidPercentage;
    return Math.min(discountedPrice, maxPrepaidDiscount || discountedPrice);
};
exports.getPrepaidDiscount = getPrepaidDiscount;
const getUsableRewardPoints = (totalAmount, paymentType, usersBalance, ruleEngine) => {
    var _a, _b, _c;
    if (usersBalance <= 0 || !(ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.enabled))
        return 0;
    const maxCashback = (_a = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.maxCashbackAllowed) !== null && _a !== void 0 ? _a : 0;
    const cashbackPercent = (_b = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.cashbackPercentage) !== null && _b !== void 0 ? _b : 0;
    const criteriaAttributes = ((_c = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.conditions) === null || _c === void 0 ? void 0 : _c.attributes) || [];
    if (!criteriaAttributes.length)
        return 0;
    const isEligible = criteriaAttributes.every((attr) => {
        if (attr.key === "totalAmount") {
            return totalAmount >= attr.value;
        }
        if (attr.key === "paymentType") {
            return paymentType === attr.value;
        }
        return true;
    }) || false;
    if (!isEligible)
        return 0;
    const cashbackUsableForThisOrder = Math.min((cashbackPercent * totalAmount) / 100, maxCashback);
    return Math.min(usersBalance, cashbackUsableForThisOrder);
};
const getAmountFromRuleEngine = (ruleEngine) => {
    const { conditions, enabled } = ruleEngine || {};
    if (!enabled) {
        return {
            isEnabled: false,
        };
    }
    const { attributes } = conditions || {};
    if (!attributes ||
        !attributes.find((attr) => {
            return attr.key === "totalAmount";
        })) {
        return {
            isEnabled: false,
        };
    }
    const attribute = attributes.find((attr) => {
        return attr.key === "totalAmount";
    });
    return {
        isEnabled: true,
        amount: attribute === null || attribute === void 0 ? void 0 : attribute.value,
        description: ruleEngine.description,
    };
};
const getRewardPoints = (totalAmount, paymentType, ruleEngine) => {
    var _a, _b, _c, _d;
    if (!(ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.enabled))
        return 0;
    const maxCashback = (_a = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.maxCashbackAllowed) !== null && _a !== void 0 ? _a : 0;
    const cashbackPercent = (_b = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.cashbackPercentage) !== null && _b !== void 0 ? _b : 0;
    const isEligible = ((_d = (_c = ruleEngine === null || ruleEngine === void 0 ? void 0 : ruleEngine.conditions) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.every((attr) => {
        if (attr.key === "totalAmount") {
            return totalAmount >= attr.value;
        }
        if (attr.key === "paymentType") {
            return paymentType === attr.value;
        }
        return true;
    })) || false;
    if (!isEligible)
        return 0;
    return Math.min(Math.floor(cashbackPercent * totalAmount) / 100, maxCashback);
};
const getShippingPrice = (payableAmount, shippingTiers, paymentMethod, appliedCoupon) => {
    if (appliedCoupon) {
        // if there is a coupon based shipping tier then return that
        const shippingTier = (shippingTiers || []).find((element) => {
            const { type, coupons, paymentType } = element;
            return (type === "COUPON" &&
                (paymentType === types_1.PaymentType.ALL || paymentType === paymentMethod) &&
                (coupons || []).includes(appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.id));
        });
        if (!!shippingTier)
            return shippingTier.amount;
    }
    if (!!(shippingTiers === null || shippingTiers === void 0 ? void 0 : shippingTiers.length)) {
        // if not found coupon based shipping tier then
        const shippingTier = (shippingTiers || []).find((element) => {
            const { type, minOrderValue, maxOrderValue, paymentType } = element;
            return (type !== "COUPON" &&
                minOrderValue <= payableAmount &&
                maxOrderValue >= payableAmount &&
                (paymentType === types_1.PaymentType.ALL || paymentType === paymentMethod));
        });
        return !!shippingTier ? shippingTier === null || shippingTier === void 0 ? void 0 : shippingTier.amount : 0;
    }
    return 0;
};
exports.getShippingPrice = getShippingPrice;
const getTargetAmountForFreeShipping = (payableAmount, shippingTiers, paymentMethod, appliedCoupon) => {
    if (appliedCoupon) {
        // if there is coupon based shipping tier then return that
        const shippingTier = (shippingTiers || []).find((element) => {
            const { type, coupons, paymentType } = element;
            return (type === "COUPON" &&
                (paymentType === "ALL" || paymentType === paymentMethod) &&
                (coupons === null || coupons === void 0 ? void 0 : coupons.includes(appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.id)));
        });
        // if exist shipping tier return
        if (!!shippingTier)
            return;
    }
    if (!!(shippingTiers === null || shippingTiers === void 0 ? void 0 : shippingTiers.length)) {
        const shippingTier = (shippingTiers || []).find((element) => {
            const { minOrderValue, maxOrderValue, paymentType } = element;
            return (minOrderValue <= payableAmount &&
                maxOrderValue >= payableAmount &&
                (paymentType === types_1.PaymentType.ALL || paymentType === paymentMethod));
        });
        return !!shippingTier ? shippingTier === null || shippingTier === void 0 ? void 0 : shippingTier.maxOrderValue : 0;
    }
    return 0;
};
exports.getTargetAmountForFreeShipping = getTargetAmountForFreeShipping;
const getCouponTotal = (coupon, cartItems) => {
    if (coupon) {
        const { discount } = (0, coupons_1.getCouponDiscount)(coupon, cartItems);
        return discount || 0;
    }
    return 0;
};
exports.getCouponTotal = getCouponTotal;
const getTotalPrice = (cartItems) => cartItems.reduce((a, b) => a + Number(b.price) * Number(b.qty), 0);
exports.getTotalPrice = getTotalPrice;
const getCartCount = (cartItems) => cartItems.reduce((a, b) => a + Number(b.qty), 0);
exports.getCartCount = getCartCount;
const getCartTotals = (cartItems, freeProducts, appliedCoupon, shippingTiers, internalPaymentType, configureCharges, debitPrepaidOrderCashbackRule, debitCodOrderCashbackRule, creditPrepaidOrderCashbackRule, creditCodOrderCashbackRule, totalRewardPointsOfUser, isRewardApplied) => {
    var _a, _b, _c, _d;
    const paymentType = internalPaymentType === cart_1.InternalPaymentType.NONE
        ? types_1.PaymentType.PREPAID
        : internalPaymentType;
    let totalPrice = 0;
    let totalListingPrice = 0;
    let totalItems = 0;
    const { codCharges = 0, prepaidDiscountPercent = 0, maxPrepaidDiscount = 0, } = configureCharges;
    const appliedCODCharges = paymentType === types_1.PaymentType.COD ? codCharges : 0;
    const couponTotal = (0, exports.getCouponTotal)(appliedCoupon, cartItems);
    for (let i = 0; i < freeProducts.length; i++) {
        totalListingPrice += freeProducts[i].price;
    }
    for (let i = 0; i < cartItems.length; i++) {
        totalPrice +=
            Number((_a = cartItems[i].price) !== null && _a !== void 0 ? _a : 0) * Number((_b = cartItems[i].qty) !== null && _b !== void 0 ? _b : 0);
        totalListingPrice +=
            Number((_c = cartItems[i].listingPrice) !== null && _c !== void 0 ? _c : 0) * Number(cartItems[i].qty);
        totalItems += Number((_d = cartItems[i].qty) !== null && _d !== void 0 ? _d : 0);
    }
    let prepaidDiscount = (0, exports.getPrepaidDiscount)(totalPrice, couponTotal, prepaidDiscountPercent, maxPrepaidDiscount);
    if (appliedCoupon && !(appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.applyPrepaidDiscount)) {
        prepaidDiscount = 0;
    }
    const totalPrepaidDiscount = couponTotal + prepaidDiscount;
    const totalDiscount = paymentType === types_1.PaymentType.PREPAID ? totalPrepaidDiscount : couponTotal;
    const totalAmountForShipping = totalPrice - couponTotal;
    const prepaidShippingCharge = (0, exports.getShippingPrice)(totalAmountForShipping, shippingTiers, types_1.PaymentType.PREPAID, appliedCoupon);
    const codShippingCharge = (0, exports.getShippingPrice)(totalAmountForShipping, shippingTiers, types_1.PaymentType.COD, appliedCoupon);
    const targetAmountForFreeShipping = (0, exports.getTargetAmountForFreeShipping)(totalAmountForShipping, shippingTiers, types_1.PaymentType.PREPAID, appliedCoupon);
    const shippingTotal = paymentType === types_1.PaymentType.PREPAID
        ? prepaidShippingCharge
        : codShippingCharge;
    const prepaidGrandTotalWithoutCashback = totalPrice + prepaidShippingCharge - totalPrepaidDiscount;
    const codGrandTotalWithoutCashback = totalPrice + codShippingCharge - couponTotal + codCharges;
    const codUsableCashback = getUsableRewardPoints(codGrandTotalWithoutCashback, types_1.PaymentType.COD, totalRewardPointsOfUser, debitCodOrderCashbackRule);
    const prepaidUsableCashback = getUsableRewardPoints(prepaidGrandTotalWithoutCashback, types_1.PaymentType.PREPAID, totalRewardPointsOfUser, debitPrepaidOrderCashbackRule);
    const codGrandTotal = codGrandTotalWithoutCashback - (isRewardApplied ? codUsableCashback : 0);
    const codCashbackRewardsOnOrder = getRewardPoints(codGrandTotal, types_1.PaymentType.COD, creditCodOrderCashbackRule);
    const prepaidGrandTotal = prepaidGrandTotalWithoutCashback -
        (isRewardApplied ? prepaidUsableCashback : 0);
    const prepaidCashbackRewardsOnOrder = getRewardPoints(prepaidGrandTotal, types_1.PaymentType.PREPAID, creditPrepaidOrderCashbackRule);
    const usableRewards = paymentType === types_1.PaymentType.PREPAID
        ? prepaidUsableCashback
        : codUsableCashback;
    const shippingAmountSaved = Math.max(0, 50 - shippingTotal);
    const totalAmountSaved = paymentType === types_1.PaymentType.PREPAID
        ? totalListingPrice -
            totalPrice +
            totalDiscount +
            shippingAmountSaved +
            codCharges
        : totalListingPrice - totalPrice + totalDiscount + shippingAmountSaved;
    const grandTotal = paymentType === types_1.PaymentType.PREPAID ? prepaidGrandTotal : codGrandTotal;
    const totalAmount = totalPrice -
        couponTotal +
        shippingTotal +
        appliedCODCharges -
        (paymentType === types_1.PaymentType.PREPAID ? prepaidDiscount : 0);
    const amountNeededToAvailCodCashback = getAmountFromRuleEngine(creditCodOrderCashbackRule);
    const amountNeededToAvailPrepaidCashback = getAmountFromRuleEngine(creditPrepaidOrderCashbackRule);
    const amountNeededToUseCodCashback = getAmountFromRuleEngine(debitCodOrderCashbackRule);
    const amountNeededToUsePrepaidCashback = getAmountFromRuleEngine(debitPrepaidOrderCashbackRule);
    const isLoyaltyRuleEnabled = paymentType === types_1.PaymentType.PREPAID
        ? !!(debitPrepaidOrderCashbackRule === null || debitPrepaidOrderCashbackRule === void 0 ? void 0 : debitPrepaidOrderCashbackRule.enabled)
        : !!(debitCodOrderCashbackRule === null || debitCodOrderCashbackRule === void 0 ? void 0 : debitCodOrderCashbackRule.enabled);
    return {
        totalItems,
        totalPrice,
        totalListingPrice,
        shippingTotal,
        couponTotal,
        prepaidDiscount,
        totalDiscount,
        totalAmountSaved,
        cartAmountSaved: totalAmountSaved,
        codGrandTotal,
        prepaidGrandTotal,
        cartGrandTotal: codGrandTotal,
        grandTotal,
        codCharges,
        appliedCODCharges,
        prepaidDiscountPercent,
        totalAmount,
        showLoyalty: isLoyaltyRuleEnabled &&
            !!totalRewardPointsOfUser &&
            (!appliedCoupon || (appliedCoupon === null || appliedCoupon === void 0 ? void 0 : appliedCoupon.isRewardApplicable)),
        usableRewards,
        totalRewardPointsOfUser,
        codCashbackRewardsOnOrder,
        prepaidCashbackRewardsOnOrder,
        amountNeededToAvailCodCashback,
        amountNeededToAvailPrepaidCashback,
        amountNeededToUseCodCashback,
        amountNeededToUsePrepaidCashback,
        totalAmountForShippingCharge: totalAmountForShipping,
        targetAmountForFreeShipping,
    };
};
exports.getCartTotals = getCartTotals;
